import styled from "styled-components";
import { down } from "styled-breakpoints";
import {
  Body as SundayBody,
  Hero as SundayHero,
  Headline as SundayHeadline,
  Title as SundayTitle,
} from "sunday-component";
import { Col } from "antd";
import { color } from "src/styles/globals";
import CommonButton from "../../Common/Button";

export const DesktopErrorImageContainer = styled(Col)`
  margin-top: 120px;
`;

export const ErrorImage = styled.img`
  ${down("sm")} {
    margin: 40px 0px 0px 0px;
    width: 200px;
    height: 200px;
  }
  width: 324px;
  height: 324px;
`;

export const ErrorContainer = styled.div`
  max-width: 613px;
  margin: 120px 0px 40px 0px;
  padding: 16px 16px 0px 16px;
`;

export const ErrorMobileContainer = styled.div`
  width: 100%;
  margin: 40px 24px 40px 24px;
`;

export const ErrorTitle = styled(SundayHero).attrs({ level: 4 })`
  color: ${color.charcoal10};
  margin-bottom: 16px;
`;

export const ErrorMobileTitle = styled(SundayHeadline).attrs({ level: 2 })`
  color: ${color.charcoal10};
  text-align: center;
  margin-bottom: 16px;
`;

export const ListItemBody = styled(SundayBody).attrs({ level: 7 })`
  color: ${color.charcoal09};
`;

export const EntryFormButton = styled(CommonButton)`
  margin-bottom: 16px;
`;
export const PlanButton = styled(CommonButton)``;

export const ButtonText = styled(SundayTitle).attrs({ level: 7 })``;

export const ButtonSectionContainer = styled.div`
  ${down("md")} {
    margin: 40px 24px 60px 24px;
  }
  margin: 40px 16px 80px 16px;
  width: 100%;
  max-width: 372px;
`;

export const UnorderList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 20px;
  margin: 0px;
`;
